import { useEffect, useState } from "react";
import { Btn, FieldLabel, Input, Modal, Sel } from "components/ui/index";
import { T } from "theme/index";
import { fmtNum, parseNum, todayStr, uid } from "utils/format";

// ── Transaction Modal ─────────────────────────────────────────────────────────
export default function TxModal({ tx, categories, wallets, onSave, onClose }) {
  const [f, setF] = useState(tx || { id:uid(), date:todayStr(), type:"expense", categoryId:"c05", walletId:"", toWalletId:"", amount:"", description:"", notes:"" });
  const set = (k, v) => setF(p => ({ ...p, [k]:v }));
  const cats = categories.filter(c => c.type === f.type);

  useEffect(() => {
    if (!cats.find(c => c.id === f.categoryId)) set("categoryId", cats[0]?.id || "");
  }, [f.type]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = () => {
    if (!f.amount || !f.date) return;
    if (f.type === "transfer" && !f.toWalletId) return;
    onSave({ ...f, amount:parseNum(f.amount) });
    onClose();
  };

  const TYPES = [
    ["income",    "💰 Masuk",     T.green],
    ["expense",   "💸 Keluar",    T.red],
    ["transfer",  "🔄 Transfer",  T.blue],
    ["investasi", "📈 Investasi", T.gold],
  ];

  return (
    <Modal title={tx ? "Edit Transaksi" : "Tambah Transaksi"} onClose={onClose}>
      {/* Type tabs */}
      <div style={{ marginBottom:14 }}>
        <FieldLabel>Tipe</FieldLabel>
        <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
          {TYPES.map(([v,l,col]) => (
            <button key={v} onClick={() => set("type",v)} style={{ flex:"1 1 calc(50% - 3px)", padding:"10px 0", borderRadius:8, cursor:"pointer", fontWeight:700, fontSize:12, border:`1px solid ${f.type===v?col:T.border}`, background:f.type===v?col+"20":T.surface, color:f.type===v?col:T.muted, WebkitTapHighlightColor:"transparent" }}>{l}</button>
          ))}
        </div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 14px" }}>
        <Input label="Tanggal" type="date" value={f.date} onChange={e => set("date",e.target.value)} />
        <Input label="Jumlah (Rp)" type="text" inputMode="numeric" value={fmtNum(f.amount)} onChange={e => set("amount",e.target.value.replace(/\D/g,""))} placeholder="0" />

        {/* Wallet selectors */}
        {wallets.length > 0 && f.type !== "transfer" && (
          <div style={{ gridColumn:"1/-1" }}>
            <Sel label={f.type==="income"?"Masuk ke Rekening":"Keluar dari Rekening"} value={f.walletId} onChange={e => set("walletId",e.target.value)}
              options={[{value:"",label:"— Pilih Rekening (opsional) —"}, ...wallets.map(w => ({ value:w.id, label:`${w.icon} ${w.name}` }))]}
            />
          </div>
        )}
        {f.type === "transfer" && (
          <>
            <div style={{ gridColumn:"1/-1" }}>
              <Sel label="Dari Rekening" value={f.walletId} onChange={e => set("walletId",e.target.value)}
                options={[{value:"",label:"— Pilih Rekening —"}, ...wallets.map(w => ({ value:w.id, label:`${w.icon} ${w.name}` }))]}
              />
            </div>
            <div style={{ gridColumn:"1/-1" }}>
              <Sel label="Ke Rekening" value={f.toWalletId} onChange={e => set("toWalletId",e.target.value)}
                options={[{value:"",label:"— Pilih Rekening —"}, ...wallets.filter(w=>w.id!==f.walletId).map(w => ({ value:w.id, label:`${w.icon} ${w.name}` }))]}
              />
            </div>
          </>
        )}

        {/* Category — not for transfer */}
        {f.type !== "transfer" && (
          <div style={{ gridColumn:"1/-1" }}>
            <Sel label="Kategori" value={f.categoryId} onChange={e => set("categoryId",e.target.value)} options={cats.map(c => ({ value:c.id, label:`${c.icon} ${c.name}` }))} />
          </div>
        )}

        <div style={{ gridColumn:"1/-1" }}>
          <Input label="Deskripsi" value={f.description} onChange={e => set("description",e.target.value)} placeholder="Keterangan singkat..." />
        </div>
        <div style={{ gridColumn:"1/-1", marginBottom:14 }}>
          <FieldLabel>Catatan (opsional)</FieldLabel>
          <textarea value={f.notes} onChange={e => set("notes",e.target.value)} rows={2} placeholder="Catatan tambahan..." style={{ width:"100%", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.text, fontSize:16, padding:"11px 12px", outline:"none", resize:"vertical", boxSizing:"border-box" }} />
        </div>
      </div>
      <div style={{ display:"flex", justifyContent:"flex-end", gap:8 }}>
        <Btn variant="ghost" onClick={onClose}>Batal</Btn>
        <Btn onClick={save} disabled={!f.amount||!f.date||(f.type==="transfer"&&(!f.walletId||!f.toWalletId))}>💾 Simpan</Btn>
      </div>
    </Modal>
  );
}
